import React from 'react';
import {useSelector} from "react-redux";
import exportCSVFile, {exportXLSXFile} from "../../utils/exportCSVFile";
import utilsFunction from "../../utils/utilsFunction";
import ExcelIcon from "../../Assets/Images/iconExcel.png"

function ExcelReviewDownloadButton(props) {


  const data = useSelector(s => s.reviewAccountReducer);
  const myData = data?.myData
  const column = myData?.column;
  const tableData = myData?.data


  const letGo = () => {


    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const fileName =
      "مرورحساب_ها" + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(column, tableData)
    //exportCSVFile(normalizeData, fileName, "")
    exportXLSXFile(normalizeData, fileName, "")

  }

  return (
    <>
      {tableData.length > 0 &&
        <div className={'w__100px'}>
          <button className={'btn btn__secondary_purple p-2 font__size__10'}
                  onClick={letGo}

          >
            دانلود اکسل
          </button>

        </div>
      }
    </>
  );
}

export default ExcelReviewDownloadButton;